import {ElementResponse} from '@shared/core';
import {RoomResponse} from '@shared/core/services/rooms-api';
import {EditRoomValues} from '../../modules/floors/components/edit-room-form/edit-room-form.component';

export enum TypeRoomEnum {
  Meeting = 'Meeting room type',
}

function isEditRoomValues(room: RoomResponse | ElementResponse | EditRoomValues): room is EditRoomValues {
  return 'type' in room;
}

const determineRoomMeetingId = (room: RoomResponse | ElementResponse | EditRoomValues) => {
  const type = isEditRoomValues(room) ? room.type : room.room_type;

  if (type === TypeRoomEnum.Meeting) {
    const meetingId = room?.meetingRoomId ? {meetingRoomId: room.meetingRoomId} : {meetingRoomId: null};
    return meetingId;
  }
  return null;
};

export default determineRoomMeetingId;
